import { AuditOutlined } from '@ant-design/icons';
import { CustomBreadcrumb } from 'components/CustomBreadcrumb';
import { EVALUATION_KIND_MAP } from 'services/graduate-enrollment/evaluations';
import { EvaluationsTabList } from './components/EvaluationsTabList';
import { IProfessorAreaAssessmentShow } from 'interfaces/professor_area/assessments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { Stack } from '@qcx/ui';
import { TagField } from '@refinedev/antd';
import { useParams } from 'react-router-dom';
import { useShow } from '@refinedev/core';

const isLoading = false;

export const EvaluationShow = () => {
  const { id, classroomId } = useParams();
  const { queryResult } = useShow({
    resource: 'professor_area/classroom_assessments',
    meta: { classroomId },
    id
  });

  const evaluation = queryResult.data?.data as IProfessorAreaAssessmentShow;

  if (!evaluation) {
    return null;
  }

  return (
    <ShowLayout
      isLoading={isLoading}
      breadcrumb={
        <CustomBreadcrumb
          label="Área do professor"
          backButton
          items={[
            {
              label: 'Turmas',
              path: '/professor_area/classrooms'
            },
            {
              label: 'Visualizar turma',
              path: `/professor_area/classrooms/show/${classroomId}?tab=evaluations`
            },
            {
              label: 'Visualizar'
            },
            {
              label: 'Avaliações'
            }
          ]}
        />
      }
    >
      <PageHeader
        title={evaluation.name}
        icon={AuditOutlined}
        meta={
          <Stack flow="row" className="!gap-1">
            <TagField color="default" value={'Avaliação'} />
            <TagField
              color="default"
              value={EVALUATION_KIND_MAP[evaluation.evaluation_kind]}
            />
          </Stack>
        }
      />
      <EvaluationsTabList evaluation={evaluation} />
    </ShowLayout>
  );
};
